export const SkeletonPill: React.FC = () => {
  return (
    <div className="flex h-[25px] w-24 shrink-0 animate-pulse items-center justify-between space-x-2 rounded-full border border-grey bg-grey px-4 py-1 text-xs leading-4 text-black md:h-[30px] lg:space-x-4 lg:leading-[20px]"></div>
  );
};
